import { Button } from 'shared/ui/Button'
import { ButtonType, ColorEnum } from 'shared/ui/Button/ui/Button'
import cls from './ButtonProfile.module.scss'
import { classNames } from 'shared/lib/classNames/classNames'
import { Text, TextSize, TextWeight } from 'shared/ui/Text/Text'
import {
    AddIcon,
    CheckIcon,
    CollectionIcon,
    DreamIcon,
    TelegramIcon,
} from 'shared/ui/Icon'

export const ButtonProfile = (props) => {
    const {
        counterAccept,
        onSwitchAccepted,
        counterWant,
        onSwitchWanted,
        className,
        readonly,
        addFriend,
        friendSaving,
        myFriends,
        userId,
        onToggleWant,
        onToggleCol,
        secondSwitcher,
        telegram,
    } = props

    let added
    if (readonly) {
        if (myFriends.includes(userId)) {
            added = true
        } else {
            added = false
        }
    }

    const onClickTelegram = () => {
        window.open(`https://t.me/${telegram}`)
    }

    const FriendIcon = added ? CheckIcon : AddIcon

    return (
        <div className={classNames(cls.ButtonContainer, {}, [className])}>
            <div className={cls.UpperButtonContainer}>
                {!readonly ? null : (
                    <Button
                        type={ButtonType.PROFILE}
                        onClick={addFriend}
                        disabled={friendSaving}
                        className={
                            added
                                ? cls.ButtonProfileAdded
                                : cls.ButtonProfileNotAdded
                        }
                    >
                        <div className={cls.Container}>
                            <FriendIcon className={cls.IconFriend} />
                            <Text
                                className={cls.Counter}
                                weight={TextWeight.SBOLD}
                                size={TextSize.S}
                            >
                                {added ? 'В друзьях' : 'В друзья'}
                            </Text>
                        </div>
                    </Button>
                )}
                {telegram && (
                    <Button
                        className={cls.telegramButton}
                        color={ColorEnum.WHITE}
                        onClick={onClickTelegram}
                        ariaLabel="Открыть Telegram"
                    >
                        <TelegramIcon className={cls.telegramIcon} />
                    </Button>
                )}
            </div>
            <div className={cls.ButtonWrapper}>
                <Button
                    type={ButtonType.PROFILE}
                    text={'Достигнуто'}
                    color={ColorEnum.WHITE}
                    counter={counterAccept}
                    onClick={onSwitchAccepted}
                    className={cls.ButtonProfile}
                />
                <Button
                    type={ButtonType.PROFILE}
                    text={'Создано'}
                    color={ColorEnum.WHITE}
                    counter={counterWant}
                    onClick={onSwitchWanted}
                    className={cls.ButtonProfile}
                />
            </div>
            <div className={cls.ChooserWrapper}>
                <button
                    onClick={onToggleWant}
                    className={classNames(cls.Chooser, {}, [
                        secondSwitcher === 'want'
                            ? cls.ChooserLeftActive
                            : null,
                    ])}
                >
                    <div className={cls.ButtonContentWrapper}>
                        <DreamIcon className={cls.Icon} />
                        <Text weight={TextWeight.SBOLD} size={TextSize.S}>
                            Мечты
                        </Text>
                    </div>
                </button>
                <button
                    onClick={onToggleCol}
                    className={classNames(cls.Chooser, {}, [
                        secondSwitcher === 'collection'
                            ? cls.ChooserRightActive
                            : null,
                    ])}
                >
                    <div className={cls.ButtonContentWrapper}>
                        <CollectionIcon className={cls.Icon} />
                        <Text weight={TextWeight.SBOLD} size={TextSize.S}>
                            Коллекции
                        </Text>
                    </div>
                </button>
            </div>
        </div>
    )
}
